// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: "AIzaSyCB23KSV9EqKqSBXBK2t7giKMgA7jtaBjQ",
  authDomain: "leadretail-qa.firebaseapp.com",
  databaseURL: "https://leadretail-qa.firebaseio.com",
  projectId: "leadretail-qa",
  storageBucket: "leadretail-qa.appspot.com",
  messagingSenderId: "693631061959",
  appId: "1:693631061959:web:2a02ca246cd4284109d3e2",
  measurementId: "G-GHFB257VR5"
};

export const requestForToken = () => {
    return getToken(messaging, { vapidKey: 'BMK-NiKj6Y2IOf_978lpH4syE8Evfqi0T9Uzj_RUzJ9DGskkE8tlQe6nDOtSJcQduHdsXjwT57tPmq9QhbD0F-c' })
      .then((currentToken) => {
        if (currentToken) {
          console.log('current token for client: ', currentToken);
          // Perform any other neccessary action with the token
        } else {
          // Show permission request UI
          console.log('No registration token available. Request permission to generate one.');
        }
      })
      .catch((err) => {
        console.log('An error occurred while retrieving token. ', err);
      });
};

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      console.log("payload", payload)
      resolve(payload);
    });
  });
  

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const messaging = getMessaging(app);
